import {Observable} from 'rxjs';
import {reset} from 'redux-form';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GroupsApi from 'web-app/react/entities/groups/api';
import * as InstitutionActions from 'web-app/react/entities/institutions/actions';

import * as Actions from './actions';
import * as Constants from './constants';

const createGroup = action$ =>
    action$.ofType(Actions.createGroup.type).mergeMap(({payload}) =>
        GroupsApi.createGroup(payload.institutionId, payload.title)
            .flatMap(({group}) => [
                Actions.createGroupSuccess.action({group}),
                InstitutionActions.fetchGroups.action(payload.institutionId),
                reset(Constants.formName),
            ])
            .catch(e => Observable.of(Actions.createGroupFailed.action(e))),
    );

export default combineEpics(createGroup);
